import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function ProductsPreview() {
  const products = [
    {
      id: 1,
      name: 'Cloche LED industrielle 240W',
      image: 'https://public.readdy.ai/ai/img_res/6342fbd1ba4fe30d9cefdc8df80cf633.jpg',
      description: 'Éclairage haute performance pour grandes hauteurs',
      power: '240W',
      efficiency: '185 lm/W',
      lifespan: '50 000h',
      specs: [
        '185 lm/W d\'efficacité',
        'Durée de vie 50 000h',
        'Étanchéité IP65'
      ]
    },
    {
      id: 2,
      name: 'Réglette LED industrielle 240W',
      image: 'https://readdy.ai/api/search-image?query=industrial%20LED%20linear%20light%20fixture%20240W%20rectangular%20luminaire%20on%20pure%20white%20background%20dramatic%20studio%20lighting%20showing%20sleek%20aluminum%20housing%20professional%20product%20photography%20ultra%20sharp%208k%20minimalist%20simple%20background&width=800&height=800&seq=product-linear-main-006&orientation=squarish',
      description: 'Solution linéaire pour allées et rayonnages',
      power: '240W',
      efficiency: '185 lm/W',
      lifespan: '50 000h',
      specs: [
        '185 lm/W d\'efficacité',
        'Optiques multiples',
        'Variation 0-10V'
      ]
    },
    {
      id: 3,
      name: 'Capteur de mouvement intelligent',
      image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20motion%20sensor%20detector%20device%20white%20housing%20with%20infrared%20lens%20professional%20product%20photography%20on%20clean%20white%20gray%20gradient%20background%20studio%20lighting%20ultra%20sharp%208k%20minimalist%20aesthetic%20commercial%20shot%20detailed%20view&width=800&height=800&seq=motion-sensor-product-main-001&orientation=squarish',
      description: 'Détection automatique pour économies d\'énergie',
      power: '12V',
      efficiency: 'Détection 360°',
      lifespan: '10 ans',
      specs: [
        'Portée jusqu\'à 12m',
        'Détection 360°',
        'Économies jusqu\'à 80%'
      ]
    },
    {
      id: 4,
      name: 'Télécommande intelligente',
      image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20LED%20remote%20control%20device%20sleek%20black%20design%20with%20digital%20display%20and%20adjustment%20buttons%20on%20clean%20white%20background%20professional%20product%20photography%20ultra%20sharp%208k%20minimalist%20simple%20background%20studio%20lighting&width=800&height=800&seq=smart-remote-control-main-001&orientation=squarish',
      description: 'Contrôle et ajustement de l\'intensité lumineuse',
      power: 'Batterie',
      efficiency: 'Sans fil',
      lifespan: '2 ans',
      specs: [
        'Portée jusqu\'à 30m',
        'Batterie 2 ans',
        'Compatibilité universelle'
      ]
    }
  ];

  return (
    <section className="relative py-4 sm:py-6 lg:py-8 bg-white overflow-hidden">
      {/* Animated Background - Desktop only avec classes CSS */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          className="absolute top-0 right-0 w-32 h-32 sm:w-80 lg:w-96 sm:h-80 lg:h-96 bg-gradient-to-br from-emerald-500/5 to-teal-500/5 rounded-full blur-3xl opacity-5 md:opacity-100"
          animate={window.innerWidth >= 768 ? {
            rotate: [0, 360],
            scale: [1, 1.2, 1],
          } : {}}
          transition={window.innerWidth >= 768 ? { duration: 30, repeat: Infinity, ease: "linear" } : {}}
        ></motion.div>
        <motion.div
          className="absolute bottom-0 left-0 w-32 h-32 sm:w-80 lg:w-96 sm:h-80 lg:h-96 bg-gradient-to-tr from-teal-500/5 to-cyan-500/5 rounded-full blur-3xl opacity-5 md:opacity-100"
          animate={window.innerWidth >= 768 ? {
            rotate: [360, 0],
            scale: [1, 1.3, 1],
          } : {}}
          transition={window.innerWidth >= 768 ? { duration: 25, repeat: Infinity, ease: "linear" } : {}}
        ></motion.div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-4 sm:mb-8 lg:mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-emerald-500/10 to-teal-500/10 border border-emerald-500/20 rounded-full px-3 sm:px-4 lg:px-5 py-1.5 sm:py-2 mb-3 sm:mb-4"
          >
            <motion.i 
              className="ri-lightbulb-line text-emerald-600 text-xs sm:text-sm md:text-base hidden md:block"
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ duration: 3, repeat: Infinity }}
            ></motion.i>
            <span className="text-[10px] sm:text-xs font-bold text-emerald-600 tracking-wide uppercase">Nos Produits</span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-2 sm:mb-3 lg:mb-4"
          >
            Solutions LED Professionnelles
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xs sm:text-sm md:text-base lg:text-lg text-slate-600 max-w-2xl mx-auto"
          >
            Découvrez notre gamme complète d'éclairages LED industriels haute performance
          </motion.p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 lg:gap-6 mb-4 sm:mb-8 lg:mb-12">
          {products.map((product, index) => (
            <motion.div
              key={index}
              initial={window.innerWidth >= 768 ? { opacity: 0, y: 20 } : false}
              whileInView={window.innerWidth >= 768 ? { opacity: 1, y: 0 } : {}}
              viewport={{ once: true }}
              transition={window.innerWidth >= 768 ? { duration: 0.6, delay: index * 0.1 } : {}}
              className="group"
            >
              <div className="bg-white rounded-lg sm:rounded-2xl lg:rounded-3xl shadow-sm border border-gray-100 overflow-hidden h-full flex flex-col">
                {/* Image Container */}
                <div className="relative overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-32 sm:h-48 lg:h-64 object-cover object-center transition-none md:transition-transform md:duration-300 md:group-hover:scale-110"
                  />
                  
                  {/* Certified Badge */}
                  <div className="absolute top-1 sm:top-2 lg:top-3 right-1 sm:right-2 lg:right-3 bg-emerald-500 text-white text-[8px] sm:text-xs lg:text-sm font-bold px-1 sm:px-2 lg:px-3 py-0.5 sm:py-1 rounded-full">
                    <span className="sm:hidden">✓</span>
                    <span className="hidden sm:inline">Certifié</span>
                  </div>

                  {/* Animated Background Pattern - Desktop only */}
                  <motion.div 
                    className="absolute inset-0 opacity-0 md:group-hover:opacity-20 transition-opacity duration-300 hidden md:block"
                    style={{
                      backgroundImage: `radial-gradient(circle at 2px 2px, rgba(16, 185, 129, 0.4) 1px, transparent 0)`,
                      backgroundSize: '12px 12px'
                    }}
                  ></motion.div>

                  {/* Decorative Corner - Desktop only */}
                  <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-bl from-emerald-500/20 to-transparent opacity-0 md:group-hover:opacity-100 transition-opacity duration-300 hidden md:block"></div>
                </div>

                {/* Content - Flex grow to push button down */}
                <div className="p-2 sm:p-4 lg:p-6 flex-1 flex flex-col">
                  {/* Product Name */}
                  <h3 className="text-xs sm:text-sm lg:text-lg font-bold text-gray-900 mb-1 sm:mb-2 lg:mb-3">
                    {product.name}
                  </h3>

                  {/* Description - Hidden on mobile */}
                  <p className="hidden sm:block text-xs lg:text-sm text-gray-600 mb-2 sm:mb-3 lg:mb-4 leading-relaxed flex-1">
                    {product.description}
                  </p>

                  {/* Specifications */}
                  <div className="space-y-1 sm:space-y-2 mb-2 sm:mb-4 lg:mb-6 flex-1">
                    {product.specs.slice(0, window.innerWidth < 640 ? 2 : 3).map((spec, specIndex) => (
                      <motion.div 
                        key={specIndex} 
                        className="flex items-center gap-1 sm:gap-2 text-gray-700"
                        whileHover={window.innerWidth >= 768 ? { x: 5 } : {}}
                        transition={window.innerWidth >= 768 ? { type: "tween" } : {}}
                      >
                        <motion.i
                          className="ri-check-line text-emerald-500 text-xs"
                          whileHover={window.innerWidth >= 768 ? { scale: 1.2, rotate: 360 } : {}}
                          transition={window.innerWidth >= 768 ? { duration: 0.3 } : {}}
                        ></motion.i>
                        <span className="text-xs">{spec}</span>
                      </motion.div>
                    ))}
                  </div>

                  {/* CTA Button - Always at bottom with mt-auto */}
                  <Link 
                    to="/nos-produits"
                    className="mt-auto block w-full px-2 sm:px-3 lg:px-4 py-1.5 sm:py-2 lg:py-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-lg sm:rounded-xl text-xs font-bold transition-none md:transition-all md:hover:from-emerald-600 md:hover:to-teal-700 md:hover:shadow-lg cursor-pointer whitespace-nowrap text-center"
                  >
                    <i className="ri-eye-line mr-1"></i>
                    <span className="hidden sm:inline">Voir les détails</span>
                    <span className="sm:hidden">Voir</span>
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="text-center"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/nos-produits"
              className="group inline-flex items-center gap-1.5 sm:gap-2 lg:gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-5 sm:px-7 lg:px-8 py-2.5 sm:py-3.5 lg:py-4 rounded-xl sm:rounded-2xl text-xs sm:text-base lg:text-lg font-bold hover:shadow-2xl hover:shadow-emerald-500/30 transition-all cursor-pointer whitespace-nowrap"
            >
              <motion.i 
                className="ri-lightbulb-line text-sm sm:text-lg lg:text-xl"
                animate={{ rotate: [0, 360] }}
                transition={{ duration: 3, repeat: Infinity }}
              ></motion.i>
              Découvrir tous nos produits
              <motion.i 
                className="ri-arrow-right-line text-sm sm:text-lg lg:text-xl group-hover:translate-x-1 transition-transform"
              ></motion.i>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
